var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ConfirmationModal',{attrs:{"name":_vm.modalName,"width":440,"title":_vm.modalTitle,"text":_vm.modalText,"confirm-button-text":"Reset","confirm-secondary-button-text":"Cancel"},on:{"confirm":_vm.removeTheme,"cancel":_vm.hideModal}})}
var staticRenderFns = []

export { render, staticRenderFns }